import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import system from "./src/theme";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }) => (
  <ChakraProvider value={system}>{element}</ChakraProvider>
);
